import recipes from './recipes.json';

export const featuredTags = ['Todas', 'Lactancia', 'Lesiones', 'Embarazo', 'Enfermeria', 'Recien nacido', 'Vacunacion'];
export const recipesData = recipes;
